import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                seeDefinitely: true,
                event_payload: 'seeRow'
            }
        ],
        searchFields: [
            {
                name: "operation",
                label: "Művelet",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedFrom",
                label: "History készítésének dátuma (tól)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "histCreatedTo",
                label: "History készítésének dátuma (ig)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "name",
                label: "Név",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "email",
                label: "E-mail",
                formSize: 3,
                formType: 'text',
                formVisible: true,
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formSize: 3,
                formType: 'text'
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "documentType",
                label: "Okmány típus",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formVisible: true,
                formSize: 3,
                formType: 'text'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "operation",
                label: "Művelet",
                sort: true,
                slot_name: "operation_format",
                visibility: true,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                sort: true,
                visibility: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "histCreatedOn",
                label: "History készítésének dátuma",
                visibility: true,
                sort: true,
                formType: "dateTime",
                slot_name: "hist_created_on_format",
            },
            {
                name: "name",
                label: "Név",
                visibility: true,
                sort: true,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                visibility: true,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "email",
                label: "E-mail",
                visibility: true,
                sort: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "birthName",
                label: "Születési név",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "motherName",
                label: "Anyja neve",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "placeOfBirth",
                label: "Születési hely",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                slot_name: "date_format",
                visibility: true,
                sort: false,
                formType: "date",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                visibility: true,
                sort: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "prefixedId",
                label: "Technikai azonosító",
                visibility: true,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "documentType",
                label: "Okmány típus",
                visibility: true,
                sort: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                visibility: true,
                sort: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "sosNumber",
                label: "S.O.S. szám",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "sex",
                label: "Nem",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },

            {
                name: "patientStatusId",
                label: "Páciens státusza",
                formVisible: true,
                viewModalShow: true,
                visibility: false,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPatientStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "student",
                label: "Diák?",
                formVisible: true,
                viewModalShow: true,
                visibility: false,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "seeEvidenceAsFeu",
                label: "FEÜ orvos láthatja szakorvosi dokumentumokat?",
                viewModalShow: true,
                formVisible: true,
                visibility: false,
                formSize: 4,
                formType: "checkbox"
            },
            {
                name: "seeFeuEvidenceAsDoctor",
                label: "Orvos láthatja FEÜ szakorvosi dokumentumokat?",
                viewModalShow: true,
                formVisible: true,
                visibility: false,
                formSize: 4,
                formType: "checkbox"
            },
            {
                name: "signCode",
                label: "Szignó kód",
                visibility: true,
                sort: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                slot_name: "created_on_format",
                visibility: false,
                sort: false,
                formType: "dateTime",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                slot_name: "modified_on_format",
                visibility: false,
                sort: false,
                formType: "dateTime",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "deleted",
                label: "Státusz",
                visibility: true,
                sort: false,
                slot_name: "deleted_format",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "clientCode",
                label: "Kliens kód",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "membershipFee",
                label: "Tagsági díj",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "membershipExpirationDate",
                label: "Tagság lejárati dátum",
                slot_name: "membexpdate_format",
                visibility: false,
                sort: false,
                formType: "date",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "membershipType",
                label: "Tagság típusa",
                visibility: false,
                sort: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "oldId",
                label: "oldId",
                visibility: false,
                sort: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
